import React from 'react';
import PropTypes from 'prop-types';
import StarRating from 'apps/cart/components/StarRating';

const Product = ({ name, rating, productUrl, imageUrl, inCarousel }) => {
  const classes = inCarousel ? '' : 'col-xs-4 col-md-2';

  return (
    <div className={`ProductBox__Wrapper ${classes}`}>
      <div className="ProductBox">
        <div className="ProductBox__product-image">
          <a href={productUrl}>
            <img src={imageUrl} />
          </a>
        </div>
        <div className="ProductBox__product-title heading--subtitle--small">
          {name}
        </div>
        <div className="ProductBox__reviews">
          {rating && <StarRating value={rating} count={5} />}
        </div>
      </div>
    </div>
  );
};

Product.propTypes = {
  name: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  productUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  inCarousel: PropTypes.bool,
};

export default Product;
